import { useRef } from "react";
import { AnyType, RefType } from "../interfaces";

type FormRefs = Record<string, RefType>;

export default function useFormRefs(formData: Record<string, AnyType>): [FormRefs, (fieldname: string) => void] {
  const refs = Object.keys(formData).reduce((acc, name) => {
    if(["business", "category", "status"].includes(name)) {
      acc[name] = useRef<HTMLSelectElement | null>(null);
    } else {
      acc[name] = useRef<HTMLInputElement | null>(null);
    }

    return acc;
  }, {} as FormRefs);

  function setFocusOnField(fieldname: string) {
    refs[fieldname]?.current?.focus();
  }

  return [refs, setFocusOnField];
}
